
import { combineReducers } from 'redux';
import dataReducer from '../reducer';


const rootReducer = combineReducers({
  data: dataReducer,
  // Add other reducers here if needed
});

export default rootReducer;
